exports.inject = function() {
  var interceptorsModule = angular.module('bbl.interceptors', []),
      servicesModule = angular.module('bbl.services', [
        'ngResource',
        'bbl.models',
        'bbl.modals',
        'bbl.directives',
        'bbl.filters',

        'bbl.services.api',
        'bbl.services.calls',
        'bbl.services.auth',
        'bbl.services.pusher',
        'bbl.services.pubsub',
        'bbl.services.plivo',
        'bbl.services.intercom',
        'bbl.services.toast',
        'bbl.services.logger-service',
        'bbl.services.simpleshare',
        'bbl.services.gtm',
        'bbl.services.socketio',
      ]),
      directivesModule = angular.module('bbl.common', []);

  require('./models');
  require('./modals');

  require('./api-service');
  require('./calls-service');
  require('./app-pubsub');
  require('./auth-service');
  require('./plivo-service');
  require('./intercom-service');
  require('./toast-service');
  require('./pusher-service');
  require('./directives');
  require('./filters');
  require('./logger-service');
  require('./simpleshare');
  require('./socket.io');

  require('./page-directives').inject(directivesModule);
  require('./auth-interceptor').inject(interceptorsModule);
  require('./conference-service').inject(servicesModule);
  require('./conferencecall-service').inject(servicesModule);
  require('./number-service').inject(servicesModule);
  require('./plan-service').inject(servicesModule);

  require('./gtm');
  require('./js-sip-service');
  require('./call-providers/telnyx');
  require('./call-manager-service');
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/index.js
 ** module id = 126
 ** module chunks = 0
 **/